import type { DefaultError, MutationObserverOptions } from "@tanstack/vue-query";
import { MutationObserver } from "@tanstack/vue-query";
import { getQueryClient } from "@verbleif/lib/src/composables/Query/queryClient";

/**
 * Run a mutation outside of setup. Goes through the same MutationCache as
 * useMutation / useAppMutation. Rejects when the mutation fails.
 */
export function executeMutation<
  TData = unknown,
  TError = DefaultError,
  TVariables = void,
  TOnMutateResult = unknown,
>(
  options: MutationObserverOptions<TData, TError, TVariables, TOnMutateResult>,
  variables: TVariables,
): Promise<TData> {
  const observer = new MutationObserver(getQueryClient(), options);
  return observer.mutate(variables).finally(() => observer.reset());
}
